import React from 'react';
import StartNow from '../../../Common-components/start-now/StartNow';
import "./Solutions.css";
import background from '../../Assets/background_images/background1.png';

const WorkValueAttitude = () => {
  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <img className='image' src={background} alt='hiring' />
        <div className='heading'> Work Values & Attitude </div>
      </div>

      <div>
        <h1 className='title'>WHAT IS THE WVA ?</h1>
        <p className='paragraph'> Employers can utilize the Work Values & Attitude (WVA) examination for employee screening, selection, and development. The results provide information on each person's strengths and dangers, and they aid in the prediction of behavior in the following important areas: </p>
        <ul className='outer-list'>
          <li>Compliance</li>
          <li>Accountability</li>
          <li>Coachability</li>
          <li>Optimism</li>
          <li>Managing Aggression</li>
          <li>Open Communication</li>
        </ul>

        <p className='paragraph'>The WVA reports provide information that enables firms to: </p>
        <ul className='outer-list'>
          <li>Reduce undesirable outcomes such as employee absenteeism, attrition, theft, fraud, and violence</li>
          <li>Facilitate collaboration, workforce involvement, efficiency, client satisfaction, profitability, and other results.</li>
        </ul>
      </div>
      <hr />

      <div>
        <h1 className='title'>BENEFITS OF USING THE WVA</h1>
        <p className='paragraph'>By offering a glimpse of an individual's natural work values and default settings, the WVA assists employers and managers in understanding how people will "fit" into jobs and company values and attitudes. The reports include insights that lead to gains in good outcomes like retention, productivity, and engagement, as well as decreases in negative outcomes like turnover, management issues, and poor organizational and culture fit. The WVA can be used for the following purposes:</p>
        <ul className='outer-list'><li>Identifying and developing world-class talent at all levels of the company</li>
          <li>Identifying individuals who "live and breathe" the organization's principles and culture.</li>
          <li>Reduce staff turnover and administrative costs associated with employing the incorrect candidates.</li>
          <li>Processes for interviewing and onboarding new employees should be improved.</li>
          <li>Management of position changes, promotions, and organizational transformation.</li>
          <li>To eliminate management issues, work discontent between employers and employees, and low workplace morale.</li>
          <li>To improve employee retention, productivity, and engagement.</li>
          <li>Absenteeism, turnover, lost expertise, lost training resources, and customer unhappiness must all be reduced.</li>
        </ul></div>
      <hr />

      <div>
        <h1 className='title'>THE DETAILS</h1>
        <ul className='outer-list'>
          <li>Fast and simple: After the applicant submits the assessment, the completed report findings are available within 1 hour.</li>
          <li>Improved Pre-Screening Insight: Employer reports provide ratings based on important personality qualities, which aid in interview shortlisting.</li>
          <li>Better Interviews: Reports give interview questions for the interviewer based on the unique outcomes of each participant.</li>
          <li>Accessibility: The entire procedure is available online 24 hours a day, seven days a week through a web site.</li>
          <li>Included in our standard assessment package.</li>
        </ul>
      </div>

      <div style={{ textAlign: 'center' }}>
        <StartNow />
      </div>
    </div>
  )
}

export default WorkValueAttitude;